// src/keycloakService.js
import Keycloak from 'keycloak-js';
import axios from 'axios';

let keycloak = null;
const axiosInstance = axios.create({
  baseURL: window.location.origin === 'https://portal.loxone.com'
    ? 'https://portal.loxone.com'
    : 'https://dev-portal.loxone.com',
  withCredentials: true,
  crossDomain: true
});


export const initKeycloak = ({ onLoad = 'check-sso' } = {}) => {
    return new Promise((resolve, reject) => {
        if (!keycloak) {
            keycloak = new Keycloak({
                url: process.env.VUE_APP_KEYCLOAK_ISSUER,
                realm: process.env.VUE_APP_KEYCLOAK_REALM,
                clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
            });
        }

        keycloak.init({
            onLoad,
            pkceMethod: 'S256',  // PKCE aktivieren
            checkLoginIframe: true,
        }).then(async (authenticated) => {
            if (authenticated) {
                // Optional: Token an Backend senden
                await sendTokenToBackend(keycloak.token);
                resolve(keycloak.token);
            } else {
                resolve(null); // nicht eingeloggt
            }
        }).catch(error => {
            console.error('Keycloak init failed', error);
            reject(error);
        });
    });
};

export const loginKeycloak = () => {
    keycloak.login({
        redirectUri: window.location.origin
    });
};

export const logoutKeycloak = () => {
    keycloak.logout({
        redirectUri: process.env.VUE_APP_APP_URL
    });
};

export const getKeycloak = () => keycloak;

// === Helper: Token an Backend schicken ===
async function sendTokenToBackend(token) {
    try {
        let formData = new FormData();
        formData.append('token', token);
        await axiosInstance({
            method: 'POST',
            url: 'api/setUserSessionCookie',
            data: formData,
        });
    } catch (e) {
        console.error('Token sending to backend failed:', e);
    }
}
